import React, {useCallback} from "react";
import ChainedContext from "@/contexts/chainedContext";
import MemberReceiver from "@/contexts/member_context/Member_Receiver";
import Schedule from "@liquidcomputing/sarstuff_reactjs-scheduler";
import API from "@/api/index.js";

const MemberSchedule = ({member}) => {

  const onGetWeek = useCallback((year, weekNum) => {
    return API.schedules.getWeek(member._id, year, weekNum);
  }, [member._id]);
  const onGetMonth = useCallback((year, month) => {
    return API.schedules.getMonth(member._id, year, month);
  }, [member._id]);
  const onUpdate = useCallback((data) => {
    return API.schedules.bulkUpdate(member._id, data);
  }, [member._id]);

  return (
    <div>
      <Schedule userId={member._id} onGetWeek={onGetWeek} onGetMonth={onGetMonth} onUpdate={onUpdate} />
    </div>
  )
};
export default ChainedContext(MemberSchedule, [
  [MemberReceiver, "member"],
]);